/* eslint-disable */
import React from "react";
import { createBrowserHistory } from "history";
import { Switch, Route } from "react-router";
import { Root } from "./Root";
import { DownloadFileRoot } from "./DownloadFileRoot";

const BulkExportRouter: React.FC = () => {
  return (
    <Switch>
      <Route path="/bulk-export/download/:fileKey" component={DownloadFileRoot} />
      <Route path="/bulk-export" component={Root} />
    </Switch>
  );
};

export default BulkExportRouter;
